import styled from 'styled-components'
import {
  flexDirection,
  FlexDirectionProps,
  padding,
  PaddingProps,
} from 'styled-system'
import { themeGet } from '@styled-system/theme-get'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

import { LANDING_CONTENT_WIDTH_PX } from 'Constants/Landing'

const shouldForwardProp = (prop: string) =>
  !DIV_SHOULD_FORWARD_PROP.includes(prop)

export const Container = styled.div.withConfig({
  shouldForwardProp,
})<FlexDirectionProps & PaddingProps>`
  display: flex;
  width: 100%;
  max-width: ${LANDING_CONTENT_WIDTH_PX}px;
  gap: ${themeGet('space.13')}px;

  ${flexDirection}
  ${padding}
`
